export default class Locale_ContractRowMenu { 
	MenuItemText: string = 'Create matching request';
	MenuItemTitle: string = 'Creates a request matching the sum of all allocations';
	StickyItemText: string = "Stickyness";
	StickyItemTitle: string = "Adds stickyness to the contract, according to the rule selected";
	MoveContractItemText: string = "Move contract";
	MoveContractItemTitle: string = "Moves a contract to another project. All historic activities stays.";
}

